module.exports = __webpack_public_path__ + "img/case_12.5b50d944.png";